var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarheaven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.37356,
    y: -1.37356,
    width: 16.7627,
    height: 16.0752
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.69px)",
      clipPath: "url(#bgblur_0_14736_17366_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 1.37356,
    d: "M9.3418 4.05371L9.37598 4.1084L9.43848 4.12402L13.7285 5.18262L10.8809 8.5625L10.8389 8.6123L10.8438 8.67578L11.1611 13.084L7.06738 11.4199L7.00781 11.3955L6.94824 11.4199L2.85352 13.084L3.17187 8.67578L3.17676 8.6123L3.13477 8.5625L0.286133 5.18262L4.57715 4.12402L4.63965 4.1084L4.67383 4.05371L7.00781 0.299805L9.3418 4.05371Z",
    fill: "#C3F0FF",
    fillOpacity: 0.8,
    stroke: "#1C9FD0",
    strokeWidth: 0.316975
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_14736_17366_clip_path",
    transform: "translate(1.37356 1.37356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3418 4.05371L9.37598 4.1084L9.43848 4.12402L13.7285 5.18262L10.8809 8.5625L10.8389 8.6123L10.8438 8.67578L11.1611 13.084L7.06738 11.4199L7.00781 11.3955L6.94824 11.4199L2.85352 13.084L3.17187 8.67578L3.17676 8.6123L3.13477 8.5625L0.286133 5.18262L4.57715 4.12402L4.63965 4.1084L4.67383 4.05371L7.00781 0.299805L9.3418 4.05371Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarheaven);
export default __webpack_public_path__ + "static/media/Starheaven.25894602ecc079f7b94ea8fa535bdf30.svg";
export { ForwardRef as ReactComponent };